module.exports = __webpack_public_path__ + "static/1322528652.f2df795c.jpg";